import React, { useMemo, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../../../components/buttons/buttons";
import Table from "../../../../../components/tables/tableCols1";
import TableSkeleton from "../../../../../components/skeleton/table";
import STORE from "../../../../../assets/images/icons/outletEmpty.svg";

import { getABusiness } from "../../../../../redux/business/businessActions";

export default function StoreBusiness({ myBusiness }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { business, isLoading } = useSelector((state) => state.business);
  const [data, setData] = useState([]);

  useEffect(() => {
    dispatch(getABusiness(myBusiness?.id));
  }, [dispatch, myBusiness]);

  function createTableData(data) {
    let dataToMap = data;
    if (Array.isArray(dataToMap)) {
      let outputArray = [];
      dataToMap.map((store, index) => {
        let single = {
          location: store?.store_city,
          num: <span className="text-base font-semibold">{index + 1}</span>,
          name: store?.store_name,
          phone: <div>{store?.store_phone}</div>,
          approval:
            store?.management_approved === true ? (
              <p className="font-bold text-sm text-green-500">Approved</p>
            ) : (
              <p className="font-bold text-sm text-primary">Unapproved</p>
            ),

          email: store?.store_email,
          store: store,
        };

        outputArray.push({ single });
        return true;
      });

      return outputArray;
    }
  }

  useEffect(() => {
    const dataSet = createTableData(business?.stores);
    setData(dataSet);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [business]);

  const goToCreate = () => {
    navigate(`/create-store`);
  };

  // const goToSinglePage = (params) => {
  //   let id = params?.single?.business?.id;
  //   navigate(`/admin/store/${id}`);
  // };

  const columns = useMemo(
    () => [
      {
        Header: "",
        hideHeader: false,
        id: "checkbox-table-column",
        // First group columns
        columns: [
          {
            Header: "S/N",
            accessor: "single.num",
          },
          {
            Header: "Name",
            accessor: "single.name",
          },
          {
            Header: "Email",
            accessor: "single.email",
          },
          {
            Header: "Location",
            accessor: "single.location",
          },
          {
            Header: "Status",
            accessor: "single.approval",
          },
          {
            Header: "Phone Number",
            accessor: "single.phone",
          },
        ],
      },
    ],
    []
  );
  return (
    <div data-test="business-page ">
      <div className=" bg-white rounded-md py-4">
        <div className="flex items-end justify-end mx-6 py-3 ">
          <Button.Primary title={"Create Store"} onClick={() => goToCreate()} />
        </div>
        <div className="border-b"></div>

        <div>
          {data?.length > 0 ? (
            <>
              {isLoading ? (
                <TableSkeleton />
              ) : (
                <Table
                  columns={columns}
                  data={data?.length > 0 ? data : []}
                  className="w-full"
                  rowClass="hover:shadow-md cursor-pointer"
                />
              )}
            </>
          ) : (
            <div className="text-center">
              {" "}
              <div className="flex justify-center my-12 ">
                <img src={STORE} alt="store" />
              </div>
              <p className="font-bold text-xl my-3">Stores</p>
              <p className="text-sm text-gray-500">You have no stores yet</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
